import { createMenu } from "./SCRIPT/menu.js";
import { drawTable } from "./SCRIPT/table.js";
import { drawAllTitles } from "./SCRIPT/drawing.js";
import { move } from "./SCRIPT/moving.js";
import { createGameContainer } from "./SCRIPT/game.js";
import { getUserById } from "./SCRIPT/api/getUserById.js";
import { pushNickname } from "./SCRIPT/api/pushNickname.js";
import dotenv from "dotenv";

dotenv.config();
const localStorageItem = window.localStorage.getItem(
  `realm-web:app(${process.env.REALM_WEB_ID}):userIds`
);
(async () => {
  if (localStorageItem) {
    const currentUserId = JSON.parse(localStorageItem)[0];
    const res = await getUserById(currentUserId);

    if (!res.success) {
      alert(res.data);
      window.localStorage.clear();
      window.location.assign("/");
      return;
    }

    if (!res.data) {
      alert("duomenys yra tušti.");
      window.localStorage.clear();
      window.location.assign("/");
      return;
    }

    if (res.data.nickname === undefined) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      const milliseconds = String(now.getMilliseconds()).padStart(3, "0");
      const dateTimeString = `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
      const guest = "guest" + dateTimeString;

      const result = await pushNickname(guest, currentUserId);
      if (!result.success) {
        alert(result.data);
        window.localStorage.clear();
        window.location.assign("/");
      }
      window.location.assign("/");
    } else {
      window.localStorage.setItem(
        "difficulty",
        JSON.stringify(res.data.difficulty)
      );
    }
  }
})();
createMenu();

export function startGame(difficulty) {
  document.getElementById("menu").style.display = "none";
  class Board {
    constructor(imgNWidth, imgNHeight, rowCols) {
      if (Board._intance) {
        throw new Error("There can be only one board per puzzle");
      }
      Board._intance = this;
      this.rowCols = rowCols;
      this.width = window.innerWidth < 450 ? window.innerWidth : 450;
      this.height = this.width;
      this.widthIP = Math.floor(imgNWidth / this.rowCols);
      this.heightIP = Math.floor(imgNHeight / this.rowCols);
      this.titleWidth = Math.floor(this.width / this.rowCols);
      this.titleHeight = Math.floor(this.height / this.rowCols);
    }
  }
  let canvas = document.getElementById("canvas");
  let ctx = canvas.getContext("2d");
  let board;
  let titleImgs = [];
  let shuffledIds = [];
  let titleIds = [];
  let clicker = 0;

  function selectImg() {
    ctx.restore();
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    let img = new Image();
    img.onload = cutImageIntoPieces;
    let number = Math.floor(Math.random() * (49 - 1)) + 1;
    img.src = `./IMG/${number}.jpg`;

    let image = document.getElementById("hintImg");
    image.src = `./IMG/${number}.jpg`;
    image.style.width = `${
      window.innerWidth < 450 ? window.innerWidth : 450
    }px`;
  }

  selectImg();

  document.getElementById("shuffle").addEventListener("click", () => {
    clicker = 0;
    document.getElementById(
      "clicker"
    ).innerText = `Atlikote paspaudimų: ${clicker}`;
    shuffle(difficulty);
    drawAllTitles(titleImgs, shuffledIds, board, ctx);
  });

  document.getElementById("shuffle-image").addEventListener("click", () => {
    clicker = 0;
    document.getElementById(
      "clicker"
    ).innerText = `Atlikote paspaudimų: ${clicker}`;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    document.getElementById("game").remove();
    createGameContainer(difficulty);
    startGame(difficulty);
  });

  document.getElementById("table").addEventListener("click", () => {
    drawTable();
  });

  document.getElementById("backToMenu").addEventListener("click", () => {
    if (document.querySelector("#game")) {
      document.querySelector("#game").remove();
    }
    document.querySelector("#menu").style.display = "flex";
  });

  function cutImageIntoPieces() {
    board = new Board(this.naturalWidth, this.naturalHeight, difficulty);
    canvas.width = board.width;
    canvas.height = board.height;

    function addClick() {
      clicker++;
      document.getElementById(
        "clicker"
      ).innerText = `Atlikote paspaudimų: ${clicker}`;
    }
    function makeMove(event) {
      move(
        event,
        shuffledIds,
        titleIds,
        titleImgs,
        ctx,
        board,
        canvas,
        addClick,
        removeClick,
        clicker
      );
    }
    canvas.addEventListener("click", makeMove);

    function removeClick() {
      canvas.removeEventListener("click", makeMove);
    }

    ctx.fillStyle = "gray";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    let tmpCanvas = document.createElement("canvas");
    tmpCanvas.width = board.titleWidth;
    tmpCanvas.height = board.titleHeight;
    let tmpCtx = tmpCanvas.getContext("2d");

    for (let row = 0; row < board.rowCols; row++) {
      for (let col = 0; col < board.rowCols; col++) {
        tmpCtx.drawImage(
          this,
          row * board.widthIP,
          col * board.heightIP,
          board.widthIP,
          board.heightIP,
          0,
          0,
          tmpCanvas.width,
          tmpCanvas.height
        );
        titleImgs.push(tmpCanvas.toDataURL());
        let id = row + col * board.rowCols;
        titleIds.push(id);
      }
    }
    shuffle(difficulty);
    drawAllTitles(titleImgs, shuffledIds, board, ctx);
  }

  function shuffle(size) {
    let shuffles;
    if (size == 3) {
      shuffles = [
        [2, 3, 4, 1, 6, 5, 8, 7, -1],
        [4, 1, 3, 7, 2, 8, 5, 6, -1],
      ];
    } else if (size == 4) {
      shuffles = [
        [2, 1, 3, 4, 6, 5, 8, 7, 9, 11, 10, 12, 13, 15, 14, -1],
        [1, 2, 3, 4, 5, 7, 8, 6, 9, 10, 11, 12, 13, 15, 14, -1],
      ];
    } else if (size == 5) {
      shuffles = [
        [
          1, 3, 4, 2, 5, 6, 8, 9, 7, 10, 11, 13, 14, 12, 15, 16, 18, 19, 17, 20,
          21, 23, 24, 22, -1,
        ],
        [
          1, 5, 2, 6, 3, 7, 4, 8, 9, 13, 10, 14, 11, 15, 12, 16, 17, 21, 18, 22,
          19, 23, 20, 24, -1,
        ],
      ];
    } else if (size == 6) {
      shuffles = [
        [
          10, 16, 33, 25, 7, 24, 1, 3, 31, 20, 6, 2, 30, 22, -1, 18, 34, 9, 19,
          26, 14, 17, 21, 27, 28, 13, 5, 4, 35, 32, 8, 11, 23, 15, 12, 29,
        ],
        [
          9, 3, 25, 32, 20, 8, 10, 31, 13, 35, 1, 30, 17, 2, -1, 33, 28, 4, 26,
          27, 7, 24, 5, 21, 6, 22, 12, 14, 34, 15, 23, 16, 19, 29, 11, 18,
        ],
      ];
    } else {
      console.error("Invalid puzzle size");
    }
    const randomIndex = Math.floor(Math.random() * shuffles.length);
    shuffledIds = shuffles[randomIndex];
  }
}
